import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import "@/router/permission"
import store from "./store"

import "@/styles/index.scss"
import "vant/lib/index.css"
// import "@/assets/fontFamily/font.css"
import loadVant from "./vantUI/index"

import "amfe-flexible"

const app = loadVant(createApp(App))
app.use(store).use(router).mount("#app")
